import * as tslib_1 from "tslib";
import * as React from 'react';
import * as Constants from '../utils/constants';
import { PrimaryButton, DefaultButton } from 'office-ui-fabric-react/lib/Button';
import createSharingMessageActionText from '../utils/createSharingMessageActionText';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';
import getSharingMessageAction from '../utils/getSharingMessageAction';
import acceptInvite from '../actions/acceptInvite';
import showCalendar from '../actions/showCalendar';
import strings from 'owa-strings/owa-sharing-strings';
import { observer } from 'mobx-react';
var styles = require('../styles/SharingAcceptButton.scss');
var SharingAcceptButton = /** @class */ (function (_super) {
    tslib_1.__extends(SharingAcceptButton, _super);
    function SharingAcceptButton(props) {
        var _this = _super.call(this, props) || this;
        _this.onAcceptButtonClicked = function (evt) {
            _this.setState({ isLoading: true });
            acceptInvite(_this.props.item.ItemId).then(function (success) {
                _this.setState({ isLoading: false, successfulAccept: success });
            });
        };
        _this.onViewCalendarButtonClicked = function (evt) {
            var newWindow = window.open();
            showCalendar(newWindow);
        };
        _this.state = { isLoading: false, successfulAccept: false };
        return _this;
    }
    SharingAcceptButton.prototype.render = function () {
        var item = this.props.item;
        var sharingMessageAction = getSharingMessageAction(item);
        return this.renderActionButton(sharingMessageAction);
    };
    SharingAcceptButton.prototype.renderActionButton = function (sharingMessageAction) {
        if (!sharingMessageAction) {
            return null;
        }
        if (this.state.isLoading) {
            return (React.createElement("div", null,
                React.createElement(Spinner, { className: styles.spinner, size: SpinnerSize.small }),
                React.createElement("span", null, strings.addingCalendarLoadingText)));
        }
        var primary = sharingMessageAction.Importance === Constants.PRIMARY_IMPORTANCE;
        if (this.state.successfulAccept) {
            var text = createSharingMessageActionText(Constants.VIEW_CALENDAR);
            return primary ? (React.createElement(PrimaryButton, { text: text, onClick: this.onViewCalendarButtonClicked })) : (React.createElement(DefaultButton, { text: text, onClick: this.onViewCalendarButtonClicked }));
        }
        else {
            var action = this.state.successfulAccept
                ? Constants.VIEW_CALENDAR
                : sharingMessageAction.Action;
            var text = createSharingMessageActionText(action);
            var primary_1 = sharingMessageAction.Importance === Constants.PRIMARY_IMPORTANCE;
            return primary_1 ? (React.createElement(PrimaryButton, { text: text, onClick: this.onAcceptButtonClicked })) : (React.createElement(DefaultButton, { text: text, onClick: this.onAcceptButtonClicked }));
        }
    };
    SharingAcceptButton = tslib_1.__decorate([
        observer
    ], SharingAcceptButton);
    return SharingAcceptButton;
}(React.Component));
export default SharingAcceptButton;
//# sourceMappingURL=SharingAcceptButton.js.map